export const pluralize = (count: number, singular: string, plural = `${singular}s`) => (
  `${count} ${count === 1 ? singular : plural}`
);

export const getDeleteErrorMessage = (error: any) => {
  const detail = error?.detail;
  if (typeof detail === 'string') {
    return detail;
  }
  if (detail?.message) {
    const connectedCount = Number(detail.presence_connection_count || 0);
    const activeConversationCount = Number(detail.active_conversation_count || 0);
    return `${detail.message} (${pluralize(connectedCount, 'connected visitor')}, ${pluralize(activeConversationCount, 'active conversation')})`;
  }
  return 'Failed to delete agent';
};
